import { FiGrid } from "react-icons/fi";
import { Btn, LI, UL } from '../../../../AbstractElements'
import {  PricingPlan } from '../../../../utils/Constant'

const PricingPlans = () => {
  return (
    <UL className='simple-list'>
      <LI>
        <Btn outline color="primary" block className="progress-text text-start">
          <FiGrid />
          {PricingPlan}
        </Btn>
      </LI>
    </UL>
  )
}

export default PricingPlans